module.exports = __webpack_public_path__ + "static/media/credit5.298a6763.svg";